var kind = require("enyo/kind");

require("./Aside.less");

module.exports = kind(/** @lends app.PlaylistPage.Aside.prototype */ {

    /**
     * @private
     */
    name: "app.PlaylistPage.Aside",

    /**
     * @private
     */
    classes: "app-playlist-page-aside",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null

});
